<fui-fields [formGroup]="editService.formGroup">
    <fui-fields formGroupName="memberRenewal">
        <fui-field>
            <wbo-date-edit-control formControlName="startDate"
                                   [(ngModel)]="model.data.memberRenewal.startDate"></wbo-date-edit-control>
        </fui-field>
        <fui-field>
            <wbo-date-edit-control formControlName="expiryDate"
                                   [(ngModel)]="model.data.memberRenewal.expiryDate"></wbo-date-edit-control>
        </fui-field>
    </fui-fields>
</fui-fields>
